import { useEffect, useMemo, useState } from 'react';
import type { BrowserTab, ConsoleEntry } from '../types';
import { proxiedUrl } from '../lib/urls';

interface Props {
  tab: BrowserTab;
  consoleEntries: ConsoleEntry[];
}

export function DevTools({ tab, consoleEntries }: Props) {
  const [html, setHtml] = useState('');
  const [edited, setEdited] = useState('');
  const [panel, setPanel] = useState<'elements' | 'console' | 'preview'>('elements');

  useEffect(() => {
    let cancelled = false;
    fetch(proxiedUrl(tab.url))
      .then((response) => response.text())
      .then((text) => { if (!cancelled) { setHtml(text); setEdited(text); } })
      .catch((error) => { if (!cancelled) { const msg = error instanceof Error ? error.message : 'Source unavailable'; setHtml(msg); setEdited(msg); } });
    return () => { cancelled = true; };
  }, [tab.url]);

  const pretty = useMemo(() => edited.replace(/></g, '>\n<'), [edited]);

  return (
    <div className="devtools-view">
      <div className="devtools-preview">
        <iframe title="Developer preview" srcDoc={panel === 'preview' ? edited : html} sandbox="allow-scripts allow-forms" />
      </div>
      <aside className="devtools-panel">
        <div className="panel-tabs">
          <button className={panel === 'elements' ? 'active' : ''} onClick={() => setPanel('elements')}>Elements</button>
          <button className={panel === 'console' ? 'active' : ''} onClick={() => setPanel('console')}>Console</button>
          <button className={panel === 'preview' ? 'active' : ''} onClick={() => setPanel('preview')}>Edited preview</button>
        </div>
        {panel === 'elements' && <textarea value={pretty} onChange={(event) => setEdited(event.target.value)} spellCheck={false} />}
        {panel === 'console' && (
          <div className="console-list">
            {consoleEntries.length === 0 && <p>No console messages captured yet.</p>}
            {consoleEntries.map((entry) => <div key={entry.id} className={`console-line ${entry.level}`}><strong>{entry.level}</strong> {entry.message}</div>)}
          </div>
        )}
        {panel === 'preview' && <textarea value={edited} onChange={(event) => setEdited(event.target.value)} spellCheck={false} />}
      </aside>
    </div>
  );
}
